module.exports = __webpack_public_path__ + "static/media/site-plan.362046e4.png";